import { getPermissionForContent } from '@/common/utils/request'
import cookie from '@/common/utils/cookie'
import _ from 'lodash'

const ACTION_STATE = {
  STREAM: 'stream',
  NONE: 'none'
}
export const actionButtonStateInfoData = async (contentType, contentInfo) => {
  const queryObj = { contenttype: contentType }
  if (contentType === 'vod') {
    const isQVOD = _.get(contentInfo, 'type', '') === 'onair'
    if (isQVOD) { queryObj.contenttype = 'qvod' }
    queryObj.contentid = _.get(contentInfo, 'contentid', '')
  } else if (contentType === 'live') {
    queryObj.contentid = _.get(contentInfo, 'channelid', '')
  } else if (contentType === 'movie') {
    queryObj.contentid = _.get(contentInfo, 'movieid', '')
  }
  const isWavveOn = cookie.isWavveOn()
  const permissionRes = await getPermissionForContent(queryObj)
  const isVisible = isWavveOn ? false : _.get(permissionRes, 'data.action') === ACTION_STATE.NONE
  const title = isWavveOn ? '시청하기' : _.get(permissionRes, 'data.display', '')
  const action = isWavveOn ? ACTION_STATE.STREAM : _.get(permissionRes, 'data.action', '')
  return { isVisible, title, action }
}
